var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 10,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 3.5C9.82482 3.49998 9.65167 3.53637 9.49231 3.60671C9.33294 3.67705 9.19108 3.7797 9.07632 3.90769C8.96157 4.03568 8.87662 4.18603 8.82722 4.34855C8.77782 4.51107 8.76512 4.68196 8.79 4.84964C7.90427 5.1025 7.1269 5.62563 6.57398 6.3409C6.02107 7.05616 5.72227 7.92518 5.72222 8.81818V13.5455H5.11111C4.94903 13.5455 4.7936 13.6077 4.67899 13.7185C4.56438 13.8293 4.5 13.9796 4.5 14.1364C4.5 14.2931 4.56438 14.4434 4.67899 14.5542C4.7936 14.665 4.94903 14.7273 5.11111 14.7273H14.8889C15.051 14.7273 15.2064 14.665 15.321 14.5542C15.4356 14.4434 15.5 14.2931 15.5 14.1364C15.5 13.9796 15.4356 13.8293 15.321 13.7185C15.2064 13.6077 15.051 13.5455 14.8889 13.5455H14.2778V8.81818C14.2777 7.92518 13.9789 7.05616 13.426 6.3409C12.8731 5.62563 12.0957 5.1025 11.21 4.84964C11.2349 4.68196 11.2222 4.51107 11.1728 4.34855C11.1234 4.18603 11.0384 4.03568 10.9237 3.90769C10.8089 3.7797 10.6671 3.67705 10.5077 3.60671C10.3483 3.53637 10.1752 3.49998 10 3.5ZM11.2222 15.9091C11.2222 16.0658 11.1578 16.2161 11.0432 16.3269C10.9286 16.4377 10.7732 16.5 10.6111 16.5H9.38889C9.22681 16.5 9.07137 16.4377 8.95677 16.3269C8.84216 16.2161 8.77778 16.0658 8.77778 15.9091C8.77778 15.7524 8.84216 15.6021 8.95677 15.4913C9.07137 15.3804 9.22681 15.3182 9.38889 15.3182H10.6111C10.7732 15.3182 10.9286 15.3804 11.0432 15.4913C11.1578 15.6021 11.2222 15.7524 11.2222 15.9091Z",
    fill: "#5AB2AE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationIcon1);
export default __webpack_public_path__ + "static/media/notification_icon_1.64a0fd3882fa162460e3306251df560f.svg";
export { ForwardRef as ReactComponent };